import { redirect } from 'react-router-dom';
import { captureException } from '@sentry/react';
import {
  fetchServiceTypesForPatient,
  fetchUpcomingVisits,
  fetchVisit,
} from '@api';
import { useApplicationStore } from '@data';
import { SERVICES_ROUTE_PATHNAME } from '@router/routes/routePathnames';
import { refetchAndSetPatientProfile } from './utils';

export default async function bookingConfirmationLoader(): Promise<Response | null> {
  const { patient, serviceTypes, setServiceTypes, visit } =
    useApplicationStore.getState();
  const { patientProfile, setUpcomingVisits, setVisitDetail } = patient;

  if (!patientProfile) {
    try {
      await refetchAndSetPatientProfile();
    } catch {
      return redirect(SERVICES_ROUTE_PATHNAME);
    }
  }
  try {
    if (!serviceTypes.length) {
      const serviceTypesRes = await fetchServiceTypesForPatient();
      setServiceTypes(serviceTypesRes);
    }

    // If patient just booked a visit, fetch its visit details...
    if (visit?.visitId) {
      const visitDetails = await fetchVisit(visit.visitId);
      setVisitDetail(visitDetails);

      return null;
    }

    // Otherwise, fetch the details of the soonest visit
    const upcomingVisits = await fetchUpcomingVisits();
    setUpcomingVisits(upcomingVisits);

    // Otherwise, fetch the details of the soonest visit
    const upcomingVisit = upcomingVisits?.[0];

    if (upcomingVisit) {
      const visitRes = await fetchVisit(upcomingVisit.visitId);
      setVisitDetail(visitRes);
    }
  } catch (error) {
    // TODO: Handle error https://quick-md.atlassian.net/browse/QMD-1388
    captureException(error);
  }

  return null;
}
